<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5New';
    import SignInPC from '../components/pcNew';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '产品经理稳进大厂的绿色通道！',
                desc: '名企私教手把手打造大厂 PM 硬核技能',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210812/1628756454823.png'
            });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>
